<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :actions="actions"
    :form="form"
    :title="$t('profile')"
    :onFetchData="onFetchData"
    :onFormSubmit="onFormSubmit"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { columnsExtend, formColumnsExtend } from '../../admin_grapes/users.js';
import VueQrcode from '@chenfengyuan/vue-qrcode';

@Component
export default class Profile extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    const array = [
      'screen_name',
      'email',
      'phone'
    ]

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'phone'
    ]

    return formColumnsExtend(array, { data, type })
  }
 /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   */
  actions({ row }, { reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'profile.edit' },
          can: []
        }
      },
      !row.wechat_official_account_user_oauth_identity_account_id && {
        component: 'button',
        props: {
          label: '微信号绑定二维码',
          type: 'primary'
        },
        on: {
          click: async () => {
            const data = await this.$request.put('/mine/refresh_bind_wechat_official_account_redirect_url')

            this.$msgbox({
              message: this.$createElement('div', { style: { textAlign: 'center' } }, [
                this.$createElement(VueQrcode, { props: { value: data.redirect_url } }),
                this.$createElement('div', '二维码将于30分钟后失效，请尽快绑定'),
              ])
            });
          }
        }
      },
      row.wechat_official_account_user_oauth_identity_account_id && {
        component: 'confirmButton',
        props: {
          label: '解绑微信号',
          type: 'primary'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.delete(`/user_oauth_identity_accounts/${row.wechat_official_account_user_oauth_identity_account_id}`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'routeButton',
        props: {
          label: this.$t('changePassword'),
          to: { name: 'profile.change_password' },
          can: []
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get('/mine');
      return { data };
    }
  }

  async onFormSubmit({ data }) {
    const body = data;

    await this.$request.put('mine', body);
    this.$message.success('更新成功');
    this.$router.push({ name: 'profile.show' });
  }
}

export const route = [
  {
    path: '/profile',
    name: 'profile.show',
    component: Profile,
    props: {
      type: 'show',
    },
    meta: {
      can: ['admin_users.read']
    }
  },
  {
    path: '/profile/edit',
    name: 'profile.edit',
    component: Profile,
    props: {
      type: 'edit'
    }
  }
]
</script>
